import { Route, Switch } from "react-router-dom";
import MuralListagemPage from './Listagem';
import MuralDetalhesPage from './Detalhes';

function MuralPages() {
    return (
        <Switch>
            <Route
                exact
                path="/administracao/mural"
                component={MuralListagemPage}
            />
            <Route
                exact
                path="/administracao/mural/criar"
                component={MuralDetalhesPage}
            />
            <Route
                exact
                path="/administracao/mural/:id"
                component={MuralDetalhesPage}
            />
        </Switch>
    )
}

export default MuralPages;